export default "__VITE_ASSET__aRZFDRNy__"